export default __webpack_public_path__ + "static/media/firelance.5df2acd9.png";